/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_IndustryInputs */

const en_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Industry`)
};

const de_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branche`)
};

const fr_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Secteur`)
};

const es_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sector`)
};

const it_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Settore`)
};

const nl_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sector`)
};

const pl_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branża`)
};

const fi_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toimiala`)
};

const da_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Branche`)
};

const sv_jobs_industry = /** @type {(inputs: Jobs_IndustryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bransch`)
};

/**
* | output |
* | --- |
* | "Industry" |
*
* @param {Jobs_IndustryInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const jobs_industry = /** @type {((inputs?: Jobs_IndustryInputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_IndustryInputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_jobs_industry(inputs)
	if (locale === "fr") return fr_jobs_industry(inputs)
	if (locale === "es") return es_jobs_industry(inputs)
	if (locale === "it") return it_jobs_industry(inputs)
	if (locale === "nl") return nl_jobs_industry(inputs)
	if (locale === "pl") return pl_jobs_industry(inputs)
	if (locale === "fi") return fi_jobs_industry(inputs)
	if (locale === "da") return da_jobs_industry(inputs)
	if (locale === "sv") return sv_jobs_industry(inputs)
	return en_jobs_industry(inputs)
});